<script>
  import StatDiff from "./../components/StatDiff.svelte";
  export let data;
  export let lastUpdate;

  let statistics = [];

  $: {
    if (lastUpdate) lastUpdate.getTime(); // HACK
    if (!!data) {
      statistics = data.statistics;
    }
  }
</script>

{#if !!statistics && statistics.length > 0}
  <section class="app-stats">
    <ul>
      {#each statistics as stat}
        <li>
          <StatDiff {stat} {lastUpdate} />
        </li>
      {/each}
    </ul>
  </section>
{/if}
